import { createSelector } from 'reselect';

import { AppState } from '../../../../../store/models/app-state';

const getSupplierDetailState = (state: AppState) => state.contactsAndOrganizations.suppliers.supplierDetail;

// Add other valid states here
export const supplierDetailIsValidSelector = createSelector(
    getSupplierDetailState,
    state => state.overview.isValid && state.conditions.isValid && state.supplierExternalCustomerMappings.isValid
);
